module.exports = __webpack_public_path__ + "img/slider1.790e13ee.svg";